module.exports = __webpack_public_path__ + "static/media/egypt-quest-web.0405fa67.jpg";